import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import toast, { Toaster } from "react-hot-toast";
import { useLazyGetSearchBatchListQuery } from "../../../State/Api/AddPurchaseApiSlice";

const BatchSelectModal = ({ open, onClose, onSelect, productId, productName }) => {
  const [searchValue, setSearchValue] = useState("");
  const [batches, setBatches] = useState([]);
  const [triggerGetBatches, { isFetching }] = useLazyGetSearchBatchListQuery();

  useEffect(() => {
    console.log("Searching Batch", searchValue);
    if (!open) return;
    const pharmaId = localStorage.getItem("userUniqueID");
    if (!pharmaId || !productId) return;

    const fetchBatches = async () => {
      try {
        const result = await triggerGetBatches({
          pharmaId,
          ProductID: productId,
          batchnum: searchValue.trim() ? searchValue : undefined,
        }).unwrap();

        if (Array.isArray(result) && result.length > 0) {
          setBatches(result);
        } else {
          setBatches([]);
        }
      } catch (err) {
        console.error("Error fetching batches:", err);
        setBatches([]);
      }
    };

    const debounce = setTimeout(fetchBatches, 400);
    return () => clearTimeout(debounce);
  }, [searchValue, triggerGetBatches, open]);

  const handleCreateNewBatch = () => {
  onSelect({
  batchNo: searchValue,    
  isNewBatch: true,
});
    onClose();
    toast.success(`New batch "${searchValue}" created!`);
  };

  if (!open) return null;


  return (
    <>
      <style>
        {`
        .batch-modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1100;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .batch-modal-content {
          background: #fff;
          border-radius: 12px;
          width: 1000px;
          max-width: 95vw;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
          min-height: 500px;
          max-height: 85vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
        .batch-modal-search-row {
          padding: 18px 24px 16px 24px;
          display: flex;
          align-items: center;
          gap: 10px;
          border-bottom: 1px solid #e5e7eb;
        }
        .batch-modal-search-box {
          flex: 1;
          font-size: 14px;
          padding: 10px 16px 10px 40px;
          border: 2px solid #d1d5db;
          border-radius: 8px;
          outline: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cpath d='m21 21-4.35-4.35'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: 12px center;
          background-size: 18px;
        }
        .batch-modal-search-box:focus {
          border-color: #10b981;
        }
        .batch-modal-table-container {
          overflow-y: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .batch-modal-table {
          width: 100%;
          border-collapse: collapse;
        }
        .batch-modal-table th,
        .batch-modal-table td {
          text-align: left;
          padding: 14px 16px;
          border-bottom: 1px solid #f3f4f6;
        }
        .batch-modal-table th {
          color: #6b7280;
          font-size: 11px;
          background: #fafafa;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          position: sticky;
          top: 0;
          z-index: 10;
        }
        .batch-modal-table tbody tr {
          cursor: pointer;
          transition: background 0.15s;
        }
        .batch-modal-table tbody tr:hover {
          background: #f9fafb;
        }
        .batch-no-cell {
          font-weight: 600;
          color: #1f2937;
          font-size: 14px;
        }
        .batch-pack-cell {
          color: #374151;
          font-size: 13px;
          font-weight: 500;
        }
        .batch-mrp-cell {
          color: #1f2937;
          font-weight: 600;
          font-size: 14px;
        }
        .batch-text-cell {
          font-size: 13px;
          color: #6b7280;
        }
        .create-new-batch-row {
          cursor: pointer;
          padding: 16px 24px;
          background: #f0fdf4;
          border-bottom: 1px solid #dcfce7;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .create-new-batch-row:hover {
          background: #dcfce7;
        }
        .create-new-batch-text {
          font-size: 14px;
          color: #059669;
          font-weight: 600;
          margin: 0;
        }
        .create-new-batch-number {
          font-weight: 700;
          color: #047857;
        }
        .create-new-batch-icon {
          color: #10b981;
          margin-left: auto;
          font-size: 18px;
        }
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          text-align: center;
        }
        .empty-state-text {
          font-size: 15px;
          color: #6b7280;
          margin: 0;
        }
        .keyboard-hint {
          position: absolute;
          bottom: 16px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 13px;
          color: #9ca3af;
          padding: 12px;
          background: linear-gradient(to top, rgba(255,255,255,0.98), rgba(255,255,255,0));
        }
        `}
      </style>
      
   <div
        className="batch-modal-backdrop"
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="batch-modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "#fff",
            borderRadius: "10px",
            width: "900px",
            maxWidth: "95vw",
            maxHeight: "90vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              padding: "20px 24px 16px 24px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div>
              <h3
                style={{
                  fontSize: "18px",
                  margin: 0,
                  color: "#111827",
                  fontWeight: "600",
                }}
              >
                Search Batch for '{productName || "Product"}'
              </h3>
              <p
                style={{
                  fontSize: "13px",
                  color: "#6b7280",
                  marginTop: "4px",
                  marginBottom: 0,
                }}
              >
                Start typing to search available batches
              </p>
            </div>
            <button
              onClick={onClose}
              style={{
                fontSize: "20px",
                border: "none",
                background: "none",
                color: "#9ca3af",
                cursor: "pointer",
                padding: "4px",
                lineHeight: 1,
              }}
            >
              ✕
            </button>
          </div>

          {/* Search bar */}
          <div
            style={{
              padding: "16px 24px",
              borderBottom: "1px solid #eee",
              position: "relative",
            }}
          >
            <input
              type="text"
              placeholder="Search batch number..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 36px 8px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
              autoFocus
            />
            <FiSearch
              style={{
                position: "absolute",
                right: "34px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#555",
                fontSize: "18px",
              }}
            />
          </div>

          {/* Table / Empty / Create */}
          <div style={{ overflowY: "auto", flex: 1 }}>
            {isFetching ? (
              <p
                style={{
                  textAlign: "center",
                  padding: "20px",
                  fontSize: "14px",
                  color: "#555",
                }}
              >
                Loading batches...
              </p>
            ) : batches.length > 0 ? (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr style={{ background: "#f9fafb", borderBottom: "1px solid #ddd" }}>
                    <th style={thStyle}>BATCH NO</th>
                    <th style={thStyle}>PACK</th>
                    <th style={thStyle}>EXPIRY</th>
                    <th style={thStyle}>MRP</th>
                    <th style={thStyle}>STATUS</th>
                    <th style={thStyle}>PURC RATE</th>
                    <th style={thStyle}>HSN</th>
                    <th style={thStyle}>GST</th>
                  </tr>
                </thead>
                <tbody>
                  {batches.map((batch, i) => (
                    <tr
                      key={i}
                      onClick={() => {
                        onSelect(batch);
                        onClose();
                        toast.success("Batch selected!");
                      }}
                      style={{
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        transition: "background 0.2s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                    >
                      <td style={tdStyle}>{batch.batchNo}</td>
                      <td style={tdStyle}>{batch.pack}</td>
                      <td style={tdStyle}>{batch.expiry}</td>
                      <td style={tdStyle}>{batch.mrp ? `₹${batch.mrp}` : "-"}</td>
                      <td style={tdStyle}>{batch.status || "-"}</td>
                      <td style={tdStyle}>{batch.purchaseRate || "-"}</td>
                      <td style={tdStyle}>{batch.hsnCode || "-"}</td>
                      <td style={tdStyle}>{batch.gst ? `${batch.gst}%` : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <>
                {searchValue.trim() ? (
                  <div
                    onClick={handleCreateNewBatch}
                    style={{
                      padding: "16px",
                      textAlign: "center",
                      color: "#059669",
                      fontWeight: 600,
                      background: "#f0fdf4",
                      cursor: "pointer",
                    }}
                  >
                    Create new batch '{searchValue}'
                  </div>
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#777",
                      fontSize: "13px",
                    }}
                  >
                    {open ? "No batch ID found." : "Start typing to search for batches"}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <Toaster />
    </>
  );
};

const thStyle = {
  textAlign: "left",
  padding: "10px 14px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#555",
};

const tdStyle = {
  padding: "10px 14px",
  fontSize: "13px",
  color: "#111",
  fontWeight: 500,
};

export default BatchSelectModal;
